import axios from 'axios';

export default {
  getReceiptsByYear: (payload) => {
    return axios.get('/api/pv/admin/statistics/receipts-by-year', { params: { startYear: payload.startYear } })
      .then(response => ({
        years: response.data.years != null
          ? response.data.years : [],
        total: response.data.total != null
          ? response.data.total : 0,
      }));
  },

  getActivationsByYear: (payload) => {
    return axios.get('/api/pv/admin/statistics/activations-by-year', { params: { startYear: payload.startYear } })
      .then(response => ({
        years: response.data.years != null
          ? response.data.years : [],
        total: response.data.total != null
          ? response.data.total : 0,
      }));
  },

  getActivationsLivePerMonth: (payload) => {
    return axios.get('/api/pv/admin/statistics/activations-live-per-month', { params: { year: payload.year, module: payload.module || undefined } })
      .then(response => ({
        months: response.data.months != null
          ? response.data.months : [],
        markets: response.data.markets != null
          ? response.data.markets : [],
      }));
  },

  getActivationModules: (payload) => {
    return axios.get('/api/pv/admin/statistics/activation-modules', { params: { year: payload.year } })
      .then(response => ({
        modules: response.data.modules != null
          ? response.data.modules : [],
      }));
  },

  getReceiptsPerActivation: (payload) => {
    return axios.get('/api/pv/admin/statistics/receipts-per-activation', { params: { year: payload.year } })
      .then(response => ({
        activations: response.data.activations != null
          ? response.data.activations : [],
        total: response.data.total != null
          ? response.data.total : 0,
      }));
  },

  getCompanyReceiptsOverview: (payload) => {
    return axios.get(`/api/pv/admin/companies/${payload.companyId}/statistics/receipts-overview`, { params: { from: payload.from, to: payload.to, market: payload.market, campaign: payload.campaign } })
      .then(response => ({
        receiptsInitiated: response.data.receiptsInitiated != null
          ? response.data.receiptsInitiated : 0,
        receiptsApproved: response.data.receiptsApproved != null
          ? response.data.receiptsApproved : 0,
        productRegistrations: response.data.productRegistrations != null
          ? response.data.productRegistrations : 0,
        ctaDone: response.data.ctaDone != null
          ? response.data.ctaDone : 0,
        cashbackDone: response.data.cashbackDone != null
          ? response.data.cashbackDone : 0,
        receiptsInitiatedForMarket: response.data.receiptsInitiatedForMarket,
        receiptsApprovedForMarket: response.data.receiptsApprovedForMarket,
        productRegistrationsForMarket: response.data.productRegistrationsForMarket,
        ctaDoneForMarket: response.data.ctaDoneForMarket,
        cashbackDoneForMarket: response.data.cashbackDoneForMarket,
      }));
  },

  getCompanyCashbacksByMarket: (payload) => {
    return axios.get(`/api/pv/admin/companies/${payload.companyId}/statistics/cashbacks-by-market`, { params: { from: payload.from, to: payload.to, campaign: payload.campaign, done: payload.done, success: payload.success } })
      .then(response => ({
        months: response.data.months != null
          ? response.data.months : [],
        markets: response.data.markets != null
          ? response.data.markets : [],
        unsupportedCurrencies: response.data.unsupportedCurrencies != null
          ? response.data.unsupportedCurrencies : [],
      }));
  },

  getCompanyReceiptsByItemMatch: (payload) => {
    return axios.get(`/api/pv/admin/companies/${payload.companyId}/statistics/receipts-by-item-match`, { params: { from: payload.from, to: payload.to, market: payload.market, campaign: payload.campaign } })
      .then(response => ({
        items: response.data.items != null
          ? response.data.items : [],
        total: response.data.total != null
          ? response.data.total : 0,
      }));
  },

  // Final report: registration-status funnel per market - counts are index-aligned with markets.
  getCompanyStatusesByMarket: (payload) => {
    return axios.get(`/api/pv/admin/companies/${payload.companyId}/statistics/statuses-by-market`, { params: { from: payload.from, to: payload.to, campaign: payload.campaign } })
      .then(response => ({
        markets: response.data.markets || [],
        stages: response.data.stages || [],
      }));
  },

  // Final report: products per market, every market as its own column -
  // counts/marketTotals are index-aligned with markets.
  getCompanyItemMatchesByMarket: (payload) => {
    return axios.get(`/api/pv/admin/companies/${payload.companyId}/statistics/item-matches-by-market`, { params: { from: payload.from, to: payload.to, campaign: payload.campaign } })
      .then(response => ({
        markets: response.data.markets != null
          ? response.data.markets : [],
        items: response.data.items != null
          ? response.data.items : [],
        marketTotals: response.data.marketTotals != null
          ? response.data.marketTotals : [],
        total: response.data.total != null
          ? response.data.total : 0,
      }));
  },

  getCompanyReceiptsByRetailer: (payload) => {
    return axios.get(`/api/pv/admin/companies/${payload.companyId}/statistics/receipts-by-retailer`, { params: { from: payload.from, to: payload.to, market: payload.market, campaign: payload.campaign } })
      .then(response => ({
        items: response.data.items != null
          ? response.data.items : [],
        total: response.data.total != null
          ? response.data.total : 0,
      }));
  },

  getCompanyMarkets: (payload) => {
    return axios.get(`/api/pv/admin/companies/${payload.companyId}/statistics/markets`)
      .then(response => ({
        markets: response.data.markets != null
          ? response.data.markets : [],
      }));
  },

  getCompanyReceiptsWeeklyByMarket: (payload) => {
    return axios.get(`/api/pv/admin/companies/${payload.companyId}/statistics/receipts-weekly-by-market`, { params: { from: payload.from, to: payload.to, campaign: payload.campaign } })
      .then(response => ({
        weeks: response.data.weeks != null
          ? response.data.weeks : [],
        markets: response.data.markets != null
          ? response.data.markets : [],
      }));
  },

  getCompanyCampaigns: (payload) => {
    return axios.get(`/api/pv/admin/companies/${payload.companyId}/statistics/campaigns`)
      .then(response => ({
        campaigns: response.data.campaigns != null
          ? response.data.campaigns : [],
      }));
  },

  // Company-scoped: filtered server-side to
  // this company's own offer pages, across whichever markets it has offers in.
  getOfferPageViews: (payload) => {
    return axios.get(`/api/pv/admin/companies/${payload.companyId}/statistics/offer-page-views`, {
      params: { startDate: payload.startDate, endDate: payload.endDate },
    })
      .then(response => ({
        rows: response.data.rows != null
          ? response.data.rows : [],
      }));
  },

  // Same company-scoping as getOfferPageViews - just bucketed by week and
  // broken out by market instead of by page.
  getOfferPageViewsWeekly: (payload) => {
    return axios.get(`/api/pv/admin/companies/${payload.companyId}/statistics/offer-page-views-weekly`, {
      params: { startDate: payload.startDate, endDate: payload.endDate },
    })
      .then(response => ({
        weeks: response.data.weeks != null
          ? response.data.weeks : [],
        markets: response.data.markets != null
          ? response.data.markets : [],
      }));
  },

  // Not a PV endpoint - Expense lives in the main per-market enginio schema,
  // not the unified PV database, so this hits /api/admin (main), not
  // /api/pv/admin like everything else in this file.
  getExpensesPerMonth: (payload) => {
    return axios.get('/api/admin/statistics/expenses-per-month', { params: { type: payload.type, year: payload.year } })
      .then(response => ({
        months: response.data.months != null
          ? response.data.months : [],
        totalCost: response.data.totalCost != null
          ? response.data.totalCost : [],
        uniqueUsers: response.data.uniqueUsers != null
          ? response.data.uniqueUsers : [],
      }));
  },
};
